module.exports = __webpack_public_path__ + "img/img-3.14d6824a.jpg";